module.exports = __webpack_public_path__ + "img/pingshen-status03.b0e727b1.png";